import { ADD_MULTIPLE } from './constants';
import { WalletTransactionMap } from './reducer';

export const addMultipleAction = (walletTransactions: WalletTransactionMap) => ({
  type: ADD_MULTIPLE,
  walletTransactions,
});
